import { OrderType } from '@shared/types'
import { AnyObject } from 'antd/es/_util/type'
import { SorterResult } from 'antd/es/table/interface'

type MinimalSorter = Pick<SorterResult<AnyObject>, 'columnKey' | 'order'>

export const getOrderDirection = (
  sorter: MinimalSorter | MinimalSorter[]
): string | undefined => {
  if (Array.isArray(sorter) || !sorter.columnKey || !sorter.order) {
    return undefined
  }

  if (sorter.order === OrderType.DESCEND) {
    return `-${String(sorter.columnKey)}`
  }

  if (sorter.order === OrderType.ASCEND) {
    return String(sorter.columnKey)
  }

  return undefined
}
